module.exports = __webpack_public_path__ + "static/media/category-clanek.a2338645.jpg";